import React, { FC } from 'react';
import { Container } from '@src/components/Container';
import '../styles.scss';

export const Skeleton: FC = () => {
  return (
    <Container className="featured-talent-card featured-talent-card--skeleton-wrapper pulse-fade">
      <div className="featured-talent-card__skeleton-wrapper">
        <div className="featured-talent-card__skeleton-content">
          <div className="featured-talent-card__skeleton-top-section">
            <div className="featured-talent-card__skeleton-avatar" />
            <div className="featured-talent-card__skeleton-top-bar" />
            <div className="featured-talent-card__skeleton-top-bar" />
          </div>

          <div className="featured-talent-card__skeleton-right-section">
            <div className="featured-talent-card__skeleton-bar" />
            <div className="featured-talent-card__skeleton-bar" />
            <div className="featured-talent-card__skeleton-bar" />

            <div className="featured-talent-card__skeleton-circles">
              <div className="featured-talent-card__skeleton-avatar-small" />
              <div className="featured-talent-card__skeleton-avatar-small" />
              <div className="featured-talent-card__skeleton-avatar-small" />
            </div>
          </div>
        </div>

        <div className="featured-talent-card__skeleton-actions">
          <div className="featured-talent-card__skeleton-action-invite" />
          <div className="featured-talent-card__skeleton-action-hide" />
        </div>
      </div>
    </Container>
  );
};
